module.exports = __webpack_public_path__ + "static/media/feature.832ec6e0.png";